/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GuestServiceType } from './guestServiceType';
import { SortOrder } from './sortOrder';
import { GuestServicesBookingsSortField } from './guestServicesBookingsSortField';


export interface GuestServicesFilter { 
    /**
     * The page number of the result (the first page is 0)
     */
    page_number?: number;
    /**
     * The number of items returned in each page
     */
    page_size?: number;
    sort_field?: GuestServicesBookingsSortField;
    sort_order?: SortOrder;
    booking_id?: string;
    customer_id?: string;
    journey_id?: string;
    service_type?: GuestServiceType;
    creation_date_from?: string;
    creation_date_to?: string;
    service_date_from?: string;
    service_date_to?: string;
}

